(function(Drupal) {
  'use strict';

  //Customise the "telephone" field error message to not bold the text in parentheses.
  Drupal.behaviors.telephoneErrorFix = {
    attach: function(context, settings) {
      const telWrapper = context.querySelector('.js-form-item-telephone');
      if (!telWrapper) {
        return;
      }

      const processError = (wrapper) => {
        const errorElement = wrapper.querySelector('.form-item--error-message');
        if (!errorElement) {
          return;
        }

        // Check if our custom span already exists.
        // If it does, our work here is done.
        if (errorElement.querySelector('.no-bold')) {
          return;
        }

        const originalText = errorElement.textContent;
        const regex = /(\(.*?\))/;

        // Check if the error message contains the pattern that needs fixing.
        if (regex.test(originalText)) {
          const newHtml = originalText.replace(regex, '<span class="no-bold">$1</span>');
          errorElement.innerHTML = newHtml;
        }
      };

      const observer = new MutationObserver(function(mutations) {
        processError(telWrapper);
      });

      observer.observe(telWrapper, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true // Also watch for direct text changes
      });

      processError(telWrapper);
    }
  };

  // Hide the "description" field when the error message is displayed
  Drupal.behaviors.hideDescriptionField = {

    attach: function(context, settings) {
      const telWrapper = context.querySelector('.js-form-item-telephone');

      if (!telWrapper) {
        return;
      }

      const checkField = (wrapper) => {
        const errorElement = wrapper.querySelector('.form-item--error-message');
        const descriptionField = wrapper.querySelector('.description');

        // Added a null check for descriptionField to prevent more TypeErrors
        if (descriptionField) {
          if (errorElement && errorElement.style.display !== 'none') {
            descriptionField.style.display = 'none';
          }
          else {
            descriptionField.style.display = '';
          }
        }
      };

      const observer = new MutationObserver(function(mutations) {
        checkField(telWrapper);
      });

      observer.observe(telWrapper, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true // Also watch for direct text changes
      });
    }
  };

})(Drupal);
